/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocateEndpointRequest
 */
export interface LocateEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof LocateEndpointRequest
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof LocateEndpointRequest
     */
    asset?: number;
}

export function LocateEndpointRequestFromJSON(json: any): LocateEndpointRequest {
    return LocateEndpointRequestFromJSONTyped(json, false);
}

export function LocateEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocateEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': !exists(json, 'path') ? undefined : json['path'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
    };
}

export function LocateEndpointRequestToJSON(value?: LocateEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'asset': value.asset,
    };
}


